import type { Editor, Extensions, Range } from "@tiptap/core";
import CodeBlockLowlight from "@tiptap/extension-code-block-lowlight";
import Link from "@tiptap/extension-link";
import { Placeholder } from "@tiptap/extensions";
import { Markdown } from "@tiptap/markdown";
import { Table, TableCell, TableHeader, TableRow } from "@tiptap/extension-table";
import StarterKit from "@tiptap/starter-kit";
import javascript from "highlight.js/lib/languages/javascript";
import python from "highlight.js/lib/languages/python";
import typescript from "highlight.js/lib/languages/typescript";
import { lowlight } from "lowlight/lib/core";

import { SKILL_MARKDOWN_MARKED_OPTIONS } from "./parse-markdown-to-slice";
import { getSkillMarkdownSlashCommands } from "./skill-markdown-slash-commands";
import { TableControls } from "./table-controls-plugin";

lowlight.registerLanguage("python", python);
lowlight.registerLanguage("javascript", javascript);
lowlight.registerLanguage("typescript", typescript);
lowlight.registerAlias({
  python: ["py", "requests", "http"],
  javascript: ["js"],
  typescript: ["ts"],
});

const getMarkdownExtension = () =>
  Markdown.configure({
    markedOptions: SKILL_MARKDOWN_MARKED_OPTIONS,
  });

export const getSkillCollectionMarkdownBaseExtensions = (): Extensions => [
  StarterKit.configure({
    heading: { levels: [1, 2, 3] },
    codeBlock: false,
    link: false,
  }),
  CodeBlockLowlight.configure({
    lowlight,
    languageClassPrefix: "language-",
  }),
  Link.configure({
    openOnClick: false,
    autolink: true,
    linkOnPaste: true,
  }),
  Table.configure({
    resizable: true,
    HTMLAttributes: {
      class: "skill-md-table",
    },
  }),
  TableRow,
  TableHeader,
  TableCell,
  TableControls,
  getMarkdownExtension(),
];

export const getSkillCollectionMarkdownExtensions = (
  placeholder: string,
  options?: {
    onInsertFrontmatter?: ({ editor, range }: { editor: Editor; range: Range }) => void;
  },
): Extensions => [
  ...getSkillCollectionMarkdownBaseExtensions(),
  getSkillMarkdownSlashCommands(options),
  Placeholder.configure({
    placeholder,
    showOnlyWhenEditable: true,
  }),
];
